import { Model, StringUtil } from "@mcleod/core";
import {
    Button, ClickEvent, Component, DataDisplayEvent, Label, TableRow, TableRowDisplayEvent, Textbox
} from "@mcleod/components";
import { AutogenLayoutUserLogin } from "./autogen/AutogenLayoutUserLogin";

export class UserLogin extends AutogenLayoutUserLogin {
    override async onLoad() {
        this.setAllNewDevicesVisible();
    }

    private async setAllNewDevicesVisible() { // move to main class?
        const data = await Model.searchSingleRecord("common/user-settings-setup");
        if (data != null) {
            this.checkboxAllowNewDevices.visible = data.getBoolean("user_new_device_override", false) === true;
        }
    }

    async buttonToggleDeviceApprovalOnClick(event: ClickEvent) {
        const tableRow = TableRow.getContainingTableRow(event.target as Component);
        tableRow.data.set("approved", tableRow.data.get("approved") === "N" ? "Y" : "N");
        await tableRow.data.post();
        this.tableUserDevices.redisplaySingleRow(tableRow.index, tableRow.data, false, false);
    }

    tableUserDevicesOnRowDisplay(event: TableRowDisplayEvent) {
        const button = event.getTableRow().findComponentById("buttonToggleDeviceApproval") as Button;
        if (button == null) {
            return;
        }
        
        if (event.getTableRow().data.get("approved") === "N") {
            button.setProps({ caption: "Unblock this Device", color: "success" });
        }
        else {
            button.setProps({ caption: "Block this Device", color: "warning" });
        }
    }

    labelDeviceApprovedOnDataDisplay(event: DataDisplayEvent) {
        const label = event.target as Label;
        const tableRow = TableRow.getContainingTableRow(label);
        const thisDeviceId = localStorage.getItem("deviceId");
        if (tableRow.data.get("approved") === "N") {
            label.setProps({ text: "Blocked", backgroundColor: "warning", color: "warning.reverse" });
        }
        else if (tableRow.data.get("device_id") === thisDeviceId) {
            label.setProps({ text: "This Device", backgroundColor: "success", color: "success.reverse" });
        }
        else {
            label.setProps({ text: "Approved", backgroundColor: "success", color: "success.reverse" });
        }
    }

    textboxDeviceLocationOnDataDisplay(event: DataDisplayEvent) {
        const label = event.target as Textbox;
        const tableRow = TableRow.getContainingTableRow(label);
        if (StringUtil.isEmptyString(tableRow.data.get("last_ip_location"))) {
            label.text = "Unknown location";
        }
        label.tooltip = "IP address: " + tableRow.data.get("last_ip_address");
    }

    sourceUserSettingsOnDisplay() {
        const userBeingDisplayed = this.sourceUserSettings.activeRow?.get("id");
        if (!StringUtil.isEmptyString(userBeingDisplayed)) {
            this.labelDevices.visible = true;
            this.tableUserDevices.visible = true;
            this.sourceUserRecognizedDevice.search({ user_id: userBeingDisplayed });
        } else {
            this.labelDevices.visible = false;
            this.tableUserDevices.visible = false;
        }
    }
}
